import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GoogleMapsModule } from '@angular/google-maps';
import { lastValueFrom } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

import { HttpClientModule } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { LinksComponent } from './components/links/links.component';
import { RenderRichTextDirective } from './directives/render-rich-text.directive';
import { AddressComponent } from './components/address/address.component';
import { GooglePlacesService } from './services/google-places/google-places.service';
import { RecaptchaComponent } from './components/recaptcha/recaptcha.component';
import { SuperannuationComponent } from './components/superannuation/superannuation.component';
import { BsbComponent } from './components/bsb/bsb.component';
import { NumericOnlyDirective } from './directives/numeric-only.directive';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { AllowDateTimeOnlyDirective } from './directives/allow-date-time-only.directive';
import { NoSpecialCharDirective } from './directives/no-special-char.directive';
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { MaintenancePageComponent } from './components/maintenance-page/maintenance-page.component';

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (googlePlacesService: GooglePlacesService) => () => lastValueFrom(googlePlacesService.loadGoogleMaps()),
      deps: [GooglePlacesService],
      multi: true,
    },
    DatePipe,
  ],
  declarations: [
    NavbarComponent,
    FooterComponent,
    LinksComponent,
    RenderRichTextDirective,
    AddressComponent,
    BsbComponent,
    RecaptchaComponent,
    SuperannuationComponent,
    NumericOnlyDirective,
    ForbiddenComponent,
    AllowDateTimeOnlyDirective,
    NoSpecialCharDirective,
    SafeUrlPipe,
    MaintenancePageComponent,
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    LinksComponent,
    RenderRichTextDirective,
    NumericOnlyDirective,
    AddressComponent,
    RecaptchaComponent,
    SuperannuationComponent,
    BsbComponent,
    AllowDateTimeOnlyDirective,
    NoSpecialCharDirective,
    SafeUrlPipe
  ],
  imports: [
    CommonModule,
    RouterLink,
    MatSnackBarModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    GoogleMapsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormsModule,
    MatSelectModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
})
export class SharedModule {}
